module.exports = "pegasus_template/assets/vr-logo-2.gif";